import 'jquery-validation';
import 'jquery-validation/dist/additional-methods.js';
import './jquery.validate.extension.nzphone.js';
import 'tinymce';
import 'flatpickr/dist/flatpickr.min.js';
import 'jquery-ui/dist/jquery-ui.min.js';
import 'slick-carousel';

$(document).ready(function () {
	var submitAction = '';
	var eventLocation = $('.event-location').first().clone();
	var eventLocationMultipleSession = $('.multiple-session').first().clone();
	var eventLocationExcludedDate = $('.excluded-date').first().clone();

	// Set single location libraries to radio buttons
	$('.js-libraries-checkbox-item').attr("type", "radio");
	$('.js-community-venue-checkbox-item').attr("type", "radio");

	/* ==========================================================================
	Validation
	========================================================================== */

	jQuery.validator.addMethod("timeformat", function (value, element) {
		return this.optional(element) || /^(0[0-9]|1[0-2]):[0-5][0-9] [AP]M$/.test(value);
	}, "Please enter a valid time in the format '08:30 AM'");

	jQuery.validator.addMethod("starttime", function (value, element) {
		if (value === "") return this.optional(element);
		// find endtime element
		const endTimeElement = document.getElementsByName(element.name.replace("Start", "End"))[0];
		if (!endTimeElement || endTimeElement.value === "") return true;

		const startDate = element._flatpickr.selectedDates[0];
		const endDate = endTimeElement._flatpickr.selectedDates[0];
		return endDate > startDate;
	}, "Start time must be before end time");

	jQuery.validator.addMethod("tinymcerequired", function (value, element) {
		return this.optional(element) || tinymce.get(element.id).getContent({ format: 'text' }).trim().length > 0;
	}, "This field is requried");

	jQuery.validator.addMethod("costdetailsrequired", function (value, element) {
		if ($('#EventCostTypeFree').is(':checked')) {
			return true;
		}
		return value.length != 0;
	}, "This field is requried");

	$.validator.messages.accept = "Please upload an image in either jpg or png format";

	$.validator.addMethod('filesizemb', function (value, element, param) {
		if (element.files.length < 1) {
			// No files selected
			return true;
		}

		if (!element.files || !element.files[0].size) {
			// This browser doesn't support the HTML5 API
			return true;
		}

		return element.files[0].size <= param * 1024 * 1024;
	}, "Image must be less than {0}MB.");


	$.validator.addMethod("startTimeValidate", function (value, element) {

		var row = $(element).closest(".multiple-sessions tr.multiple-session");
		var start = row.find("select[name$='StartTimeHour']").val();
		start += ":" + row.find("select[name$='StartTimeMinute']").val();
		start += " " + row.find("select[name$='StartTimeMeridiem']").val();
		if (start.length < 8) return true;

		var end = row.find("select[name$='EndTimeHour']").val();
		end += ":" + row.find("select[name$='EndTimeMinute']").val();
		end += " " + row.find("select[name$='EndTimeMeridiem']").val();
		if (end.length < 8) return true;

		return Date.parse(`01/01/1970 ${end}`) > Date.parse(`01/01/1970 ${start}`)
	}, "Start time must be before end time");
	jQuery.validator.classRuleSettings.starttimehour = { startTimeValidate: true };

	/* =========================Image Dimension Validation START============================== */
	$(document).on('change', '.event-registration-image-field', function () {

		let element = this;
		let file = element.files[0];

		if (!file || !window.FileReader || !window.Image) {
			$(element).data('imagedimensions-valid', true);
			return;
		}

		let reader = new FileReader();
		reader.onload = function (e) {
			let img = new Image();
			img.onload = function () {
				let minWidth = 480;
				let minHeight = 365;
				let isValid = (img.width >= minWidth && img.height >= minHeight);
				$(element).data('imagedimensions-valid', isValid);
				$(element).valid();
			};
			img.src = e.target.result;
		};
		reader.readAsDataURL(file);
	});

	$.validator.addMethod("imagedimensions", function (value, element) {
		let isValid = $(element).data('imagedimensions-valid');
		return isValid !== false;
	}, "Please upload an image with at least 480px width and 365px height");
	jQuery.validator.classRuleSettings.eventregistrationimage = { imagedimensions: true };

	/* =========================Image Dimension Validation END============================== */

	$("#event-registration").validate({
		ignore: ':hidden:not(.form-group:visible .tinymcerequired)',
		rules: {
			'Associations': {
				required: true
			},
			'EventTypes': {
				required: true
			},
			'EventCostType': {
				required: true
			},
			'LocalWard': {
				required: true
			},
			'MainImage': {
				required: true,
				filesizemb: 2
			},
			'Image2': {
				required: false,
				filesizemb: 2
			},
			'Image3': {
				required: false,
				filesizemb: 2
			},
			'Image4': {
				required: false,
				filesizemb: 2
			},
			'Image5': {
				required: false,
				filesizemb: 2
			},
			'Image6': {
				required: false,
				filesizemb: 2
			}
		},
		messages: {
			'Associations': {
				required: "Please state how is this event associated with Auckland Council",
			},
			'EventTypes': {
				required: "Please select at least one event type",
			},
			'EventCostType': {
				required: "Please select your event cost type",
			},
			'LocalWard': {
				required: "Please select a local ward",
			},
			'MainImage': {
				required: "Please upload a main image",
			},
		},
		errorClass: 'has-error',
		errorPlacement: function (label, element) {
			label.addClass('invalid-feedback');
			if (element.attr("name") === "Associations" || element.attr("name") === "EventTypes" || element.attr("name") === "EventCostType") {
				var parent = element.closest('fieldset');
				label.appendTo(parent);
			} else {
				label.insertAfter(element);
			}
		}
	});

	$(document).on("click", "#add-event-link", function (e) {
		e.preventDefault();
		var parent = $(this).closest('.event-registration__group');
		var newIndex = parent.find('.event-link').length;
		var newSection = parent.find('.event-link').first().parent('.form-group').clone();
		newSection.find("input").each(function (index, input) {
			input.id = input.id.replace(/EventLinks_0_/g, `EventLinks_${newIndex}_`);
			input.name = input.name.replace(/EventLinks\[0\]/g, `EventLinks[${newIndex}]`);
			input.value = '';
		});
		newSection.find("label").remove();
		$(this).closest('.form-group').before(newSection);
		// limit to 6 links
		if ($(".event-link").length >= 6) {
			$(this).closest('.form-group').hide();
		}
	});

	/* ==========================================================================
	TinyMCE
	========================================================================== */

	tinymce.init({
		selector: "#EventCopy",
		plugins: "lists autoresize wordcount",
		toolbar: "bold italic | bullist numlist",
		menubar: false,
		base_url: "/dist/tinymce",
		init_instance_callback: function (editor) {
			editor.on("Change", function (e) {
				editor.save();
				// trigger validation
				$("#EventCopy").blur();
			});
		}
	});

	/* ==========================================================================
	Configure date & daterange pickers
	========================================================================== */

	flatpickrInit();

	/* ==========================================================================
	Toggles
	========================================================================== */

	$(document).on("click", "#location-single", function (e) {
		e.preventDefault();
		$(this).removeClass('button--ghost').siblings('.button').addClass('button--ghost');
		$('.event-regionwide').hide().find('input[type="hidden"]').prop('disabled', true);
		$('.event-locations').show().find('input[type="hidden"]').prop('disabled', false);
		$(".js-date-options-selector a.single-date").click();
		$('.event-location').not(':first').remove();
		$('.add-event-location, .delete-event-location').hide();
		$('.location-regionwide-explanation').hide();
		$('.js-libraries-checkbox-item').attr("type", "radio");
		$('.js-community-venue-checkbox-item').attr("type", "radio");
		$('.js-libraries-legend').html("Select Library");
		$('.js-community-venue-legend').html("Select community venue");
		updateLocationHeadings();
		disableExcludedDates(false);
		disableMultipleSessions(false);
	});

	function disableExcludedDates(disabled = true){
		// disable all excluded dates fields
		$('.excluded-dates').find('input').prop('disabled', true);
		if(!disabled) {
			// loop through locations, enable fields where ExcludeDates is checked
			$('input[name*="Locations"][name*="ExcludeDates"]').each((i, element) => {
				const isChecked = $(element).is(':checked');
				if(isChecked){
					$(element).closest('.exception-dates').next('.excluded-dates').find('input').prop('disabled', disabled);
				}
			});
		}
	}

	function disableMultipleSessions(disabled = true){
		$('table.multiple-sessions').find('input, select').prop('disabled', disabled);
		$('.single-date-picker').find('input[type="hidden"]').prop('disabled', disabled);
	}


	$(document).on("click", "#location-multiple", function (e) {
		e.preventDefault();
		$(this).removeClass('button--ghost').siblings('.button').addClass('button--ghost');
		$('.event-regionwide').hide().find('input[type="hidden"]').prop('disabled', true);
		$('.event-locations').show().find('input[type="hidden"]').prop('disabled', false);
		$(".js-date-options-selector a.single-date").click();
		$('.js-libraries-checkbox-item').attr("type", "checkbox");
		$('.js-community-venue-checkbox-item').attr("type", "checkbox");
		$('.js-libraries-legend').html("Select Libraries");
		$('.js-community-venue-legend').html("Select community venues");
		addLocation();
		$('.add-event-location, .delete-event-location').show();
		$('.location-regionwide-explanation').hide();
		disableExcludedDates(false);
		disableMultipleSessions(false);
	});


	$(document).on("click", "#location-regionwide", function (e) {
		e.preventDefault();
		$(this).removeClass('button--ghost').siblings('.button').addClass('button--ghost');
		$('.event-locations').hide().find('input[type="hidden"]').prop('disabled', true);
		$('.event-regionwide').show().find('input[type="hidden"]').prop('disabled', false);
		$('.event-location').not(':first').remove();
		$('.add-event-location, .delete-event-location').hide();
		$('.location-regionwide-explanation').show();
		disableMultipleSessions();
		disableExcludedDates();
	});

	$(document).on("change", "input[name='BookingRequired']", function () {
		$('#booking-details').toggle($(this).val());
	});

	/* ==========================================================================
	Toggle location -> event date type
	========================================================================== */

	$(document).on("click", ".js-date-options-selector a", function (e) {
		e.preventDefault();
		const parent = $(this).closest(".event-location");
		parent.find(".js-date-options-group").hide().find("input").prop("disabled", true);
		const target = parent.find($(this).data("target"));
		target.show().find("input").prop("disabled", false);
		if (target.find(".excluded-dates").length) {
			// recurring dates: ensure excluded dates remain disabled if exclude dates checkbox is unticked
			target.find(".excluded-dates input").prop("disabled", !target.find(".exclude-dates").is(":checked"));
		}
		if (target.find(".session-cb").length) {
			// complex dates: ensure time fields for unticked session rows remain disabled
			target.find(".session-cb").not(":checked").change();

			target.find(".session-cb").each(function () {
				var isChecked = $(this).is(":checked");
				var row = $(this).closest(".multiple-session");
				row.find(".time-selector select").prop("disabled", !isChecked);
			})
		}
		$(this).addClass("is-selected").siblings().removeClass("is-selected");
		parent.find("input[name$='SessionType']").val($(this).data("sessiontype"));
	});

	$(document).on("change", ".time-selector .time select", function (e) {
		const selectedValue = $(this).val();
		const id = $(this).attr("id");
		const parent = $(this).closest(".time");
		const startTime = parent.find("input[name$='Start']");
		const startTimeValue = startTime.val();
		const endTime = parent.find("input[name$='End']");
		const endTimeValue = endTime.val();
		if (id.endsWith("StartTimeHour")) {
			const updatedValue = (selectedValue.length ? selectedValue : "hh") + startTimeValue.slice(2);
			startTime.val(updatedValue);
		} else if (id.endsWith("StartTimeMinute")) {
			const updatedValue = startTimeValue.slice(0, 3) + (selectedValue.length ? selectedValue : "mm") + startTimeValue.slice(-3);
			startTime.val(updatedValue);
		} else if (id.endsWith("StartTimeMeridiem")) {
			const updatedValue = startTimeValue.slice(0, 5) + " " + (selectedValue.length ? selectedValue : "PM");
			startTime.val(updatedValue);
		} else if (id.endsWith("EndTimeHour")) {
			const updatedValue = (selectedValue.length ? selectedValue : "hh") + endTimeValue.slice(2);
			endTime.val(updatedValue);
		} else if (id.endsWith("EndTimeMinute")) {
			const updatedValue = endTimeValue.slice(0, 3) + (selectedValue.length ? selectedValue : "mm") + endTimeValue.slice(-3);
			endTime.val(updatedValue);
		} else if (id.endsWith("EndTimeMeridiem")) {
			const updatedValue = endTimeValue.slice(0, 5) + " " + (selectedValue.length ? selectedValue : "PM");
			endTime.val(updatedValue);
		}

		var fields = $("select", parent).addClass("required").filter(function () {
			return $(this).val().length == 0;
		});
		if (fields.length == 4) fields.removeClass("required");
	});

	$(document).on("change", ".js-date-options-group select.load-init", function (e) {
		$(this).closest("tr").find("select[name$='StartTimeHour']").valid();
	});

	/* ==========================================================================
	Events locations
	========================================================================== */

	$(document).on("click", "a.add-event-location", function (e) {
		e.preventDefault();
		addLocation();
	});

	$(document).on("click", "a.delete-event-location", function (e) {
		e.preventDefault();
		$(this).closest('.event-location').remove();
		if ($('.event-location').length === 1) {
			$('.delete-event-location').hide();
		}
		updateLocationHeadings();
	});

	$(document).on("change", "input[name$='OnlineOnly']", function () {
		let parent = $(this).closest('.event-location');
		if (parent.length === 0) {
			parent = $(this).closest('.event-regionwide');
		}

	    parent.find('.local-ward').toggle($(this).val() === "false");
		parent.find('.venue').toggle($(this).val() === "false");
		parent.find('.additional-details').toggle($(this).val() === "false");
		parent.find('.js-library-group').toggle($(this).val() === "false");
		parent.find('.js-community-venue-group').toggle($(this).val() === "false");
	});

	$(document).on("change", "input[name$='HostedAtLibrary']", function () {
		var parent = $(this).closest('.event-location');
		if (parent.length === 0) {
			parent = $(this).closest('.event-regionwide');
		}
		parent.find('.js-libraries').toggle($(this).val() === "true");
		if ($("#Locations_0__HostedAtCommunityVenue_Yes").is(":checked")) {
			$("#Locations_0__HostedAtCommunityVenue_No").prop("checked", true);
			parent.find('.js-community-venues').toggle($(this).val() === "false");
		}
		if ($("#Locations_99__HostedAtCommunityVenue_Yes").is(":checked")) {
			$("#Locations_99__HostedAtCommunityVenue_No").prop("checked", true);
			parent.find('.js-community-venues').toggle($(this).val() === "false");
		}
	});

	$(document).on("change", "input[name$='HostedAtCommunityVenue']", function () {
		var parent = $(this).closest('.event-location');
		if (parent.length === 0) {
			parent = $(this).closest('.event-regionwide');
		}
		parent.find('.js-community-venues').toggle($(this).val() === "true");
		if ($("#Locations_0__HostedAtLibrary_Yes").is(":checked")) {
			$("#Locations_0__HostedAtLibrary_No").prop("checked", true);
			parent.find('.js-libraries').toggle($(this).val() === "false");
		}
		if ($("#Locations_99__HostedAtLibrary_Yes").is(":checked")) {
			$("#Locations_99__HostedAtLibrary_No").prop("checked", true);
			parent.find('.js-libraries').toggle($(this).val() === "false");
		}
	});

	$(document).on("change", "#Locations_99__SelectAllLibraries", function () {
		$(".js-regionwide-checkbox-item").prop('checked', this.checked);
	});

	$(document).on("change", "#Locations_99__SelectAllCommunityVenues", function () {
		$(".js-regionwide-community-venue-checkbox-item").prop('checked', this.checked);
	});

	$(document).on("change", ".js-regionwide-checkbox-item", function () {
		const allCheckboxesAreChecked = $('.js-regionwide-checkbox-item:checked').length == $('.js-regionwide-checkbox-item').length;

		$("#Locations_99__SelectAllLibraries").prop('checked', allCheckboxesAreChecked);
	});

	$(document).on("change", ".js-regionwide-community-venue-checkbox-item", function () {
		const allCommunityVenueCheckboxesAreChecked = $('.js-regionwide-community-venue-checkbox-item:checked').length == $('.js-regionwide-community-venue-checkbox-item').length;

		$("#Locations_99__SelectAllCommunityVenues").prop('checked', allCommunityVenueCheckboxesAreChecked);
	});

	$(document).on("change", "input[name$='IsRegionWide']", function () {
		var parent = $(this).closest('.event-regionwide');
		parent.find('.regionwide-suburbs').toggle($(this).val() === "false");
	});

	$(document).on("change", "#UseEventAuthorContactDetails", function (e) {
		e.preventDefault();
		if (this.checked) {
			copyContactDetails();
		}
	});

	/* ==========================================================================
	Events location - > excluded dates
	========================================================================== */

	$(document).on("click", "a.add-excluded-date", function (e) {
		e.preventDefault();
		var parent = $(this).closest('.excluded-dates');
		var newIndex = parent.find('.excluded-date').length;
		var newSection = eventLocationExcludedDate.clone();
		var locationIndex = $(this).closest('.event-location').attr('data-index');
		newSection.find("[name$='ExcludedDates.Index']").val(newIndex);
		newSection.find("input, select, textarea").each(function (index, input) {
			input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_${locationIndex}__`)
				.replace(/ExcludedDates_[0-9]+__/g, `ExcludedDates_${newIndex}__`);
			input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[${locationIndex}]`)
				.replace(/ExcludedDates\[[0-9]+\]/g, `ExcludedDates[${newIndex}]`);
		});
		newSection.find(":disabled").prop("disabled", false);
		parent.find('table tr:last').after(newSection);
		flatpickrInit();
	});

	$(document).on("click", "button.delete-excluded-date", function (e) {
		e.preventDefault();
		// if trying to delete last item, hide entire excluded dates section instead
		if ($(this).closest('.excluded-dates').find(".excluded-date").length > 1) {
			$(this).closest('.excluded-date').remove();
		} else {
			$(this).closest('.recurring-dates').find('.exclude-dates').click();
		}
	});

	$(document).on("change", ".exclude-dates", function () {
		$(this).closest('.recurring-dates').find('.excluded-dates').toggle(this.checked);
		$(this).closest('.recurring-dates').find(".excluded-dates input").prop("disabled", !this.checked);
	});

	/* ==========================================================================
	Events location - > multiple sessions
	========================================================================== */
	function correctIndexes(table) {
		const rows = table.find("tr.multiple-session");

		rows.each(function(index, row) {
			const elements = $(row).find("input, select");

			elements.each(function(_, element) {


				if ($(element).attr('name')) {
					const matches = $(element).attr('name').match(/Locations\[([0-9]+)\]/);
					const locationIndex = matches ? matches[1] : '0';

					const newName = $(element).attr('name').replace(/(Locations\[[0-9]+\]\.MultipleSessions\[\d+\])/g, `Locations[${locationIndex}].MultipleSessions[${index}]`);
					$(element).attr('name', newName);
				}

				if ($(element).attr('id')) {
					const matches = $(element).attr('id').match(/Locations_([0-9]+)__MultipleSessions/);
					const locationIndex = matches ? matches[1] : 'no match';

					const newId = $(element).attr('id').replace(/(Locations_[0-9]+__MultipleSessions_\d+)/g, `Locations_${locationIndex}__MultipleSessions_` + index);
					$(element).attr('id', newId);
				}
			});
		});
	}

	$(document).on("click", "button.add-date-row", function (e) {
		e.preventDefault();
		
		var parent = $(this).closest('.multiple-sessions');
		var newIndex = parent.find('.multiple-session').length;
		var newSection = $(this).closest('tr').clone();
		var locationIndex = $(this).closest('.event-location').attr('data-index');

		newSection.find("[name$='MultipleSessions.Index']").val(newIndex);
		newSection.find(".add-date-row").show();
		newSection.find(".remove-date-row").show();
		newSection.find('.checkbox-item').hide();

		newSection.find('input, select, textarea').each(function (index, input) {
			if (input.id) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_${locationIndex}__`)
					.replace(/MultipleSessions_[0-9]+__/g, `MultipleSessions_${newIndex}__`);
			} else {
				input.id = `Locations_${locationIndex}__MultipleSessions_${newIndex}__Date`;
				$(input).val("");
			}
			if (input.name) {
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[${locationIndex}]`)
					.replace(/MultipleSessions\[[0-9]+\]/g, `MultipleSessions[${newIndex}]`);
			} else {
				input.name = `Locations[${locationIndex}].MultipleSessions[${newIndex}].Date`;
			}
		});

		newSection.find(".single-date-picker[type=hidden]").remove();

		newSection.find("label").each(function (index, label) {
			var l = $(label);
			l.attr('for', l.attr('for').replace(/Locations_[0-9]+__/g, `Locations_${locationIndex}__`)
				.replace(/MultipleSessions_[0-9]+__/g, `MultipleSessions_${newIndex}__`));
		});

		$(this).closest('tr').after(newSection);

		newSection.find('.single-date-picker:not([type=hidden])').each(function() {
			new flatpickr(this, {
				enableTime: false,
				altInput: true,
				altFormat: "d M Y",
				dateFormat: "Y-m-d",
				locale: {
					firstDayOfWeek: 1
				},
				disableMobile: "true",
				onChange: function (selectedDates, dateStr, instance) {
					if (dateStr)
						instance.close();

					$(instance.element).prev('input[type=hidden]').remove();
					let id = instance.element.id.replace(/Locations_[0-9]+__/g, `Locations_${locationIndex}__`)
						.replace(/MultipleSessions_[0-9]+__/g, `MultipleSessions_${newIndex}__`);
					let name = instance.element.name.replace(/Locations\[[0-9]+\]/g, `Locations[${locationIndex}]`)
						.replace(/MultipleSessions\[[0-9]+\]/g, `MultipleSessions[${newIndex}]`);

					$(`<input type='hidden'>`).insertBefore(this).attr({ id: id, name: name });
				},
				onReady: function(selectedDates, dateStr, instance) {
					$(".single-date-picker.load-init").removeClass('load-init');
				}
			});
		});

		const table = $(this).closest('table.multiple-sessions').first();
		correctIndexes(table);
	});



	$(document).on("change","input[name^='Locations'][name$='Recurrence']",function() {

		const selectedRecurrence = +$(this).val();

		const commonParent = $(this).closest('.event-registration__group-inner');
		const nearestExceptionDates = commonParent.find('.form-group.exception-dates').first();

		const nearestExcludeDateCheckbox = nearestExceptionDates.find('.exclude-dates').first();
		const nearestExcludedDates = commonParent.find('.excluded-dates').first();
		const recurringEndDate = commonParent.find('.recurring-end-date').first();
		const nearestAdditionalInformation = commonParent.find('.form-group.additional-information').first();

		if (selectedRecurrence > 0) {
			nearestExceptionDates.show();

			if (nearestExcludeDateCheckbox.prop('checked')) {
				nearestExcludedDates.show();
			} else {
				nearestExcludedDates.hide();
			}

			recurringEndDate.show();
			nearestAdditionalInformation.show();
		}
		else {
			nearestExceptionDates.hide();
			nearestExcludedDates.hide();
			recurringEndDate.hide();
			nearestAdditionalInformation.hide();
		}

	});

	$(document).on("change", ".exclude-dates", function () {

		const commonParent = $(this).closest('.event-registration__group-inner');
		const input = commonParent.find("input[name^='Locations'][name$='Recurrence']:checked").first().val();
		const nearestExceptionDates = commonParent.find('.form-group.exception-dates').first();
		const nearestExcludedDates = commonParent.find('.excluded-dates').first();
		const nearestExcludeDateCheckbox = nearestExceptionDates.find('.exclude-dates').first();
		const nearestExcludedDatesDateRage = nearestExcludedDates.find('.excluded-date-range-picker');
		const nearestExcludedDateSessionFrom = nearestExcludedDates.find('input[name*="Locations"][name*="ExcludedDates"][name*="SessionFrom"]').first();
		const nearestExcludedDateSessionTo = nearestExcludedDates.find('input[name*="Locations"][name*="ExcludedDates"][name*="SessionTo"]').first();
		if (nearestExcludeDateCheckbox.prop('checked') && (+input) > 0) {
			nearestExcludedDates.show();
			nearestExcludedDatesDateRage.each(function() {
				$(this).prop('disabled', false);
			});
			nearestExcludedDateSessionFrom.prop('disabled', false);
			nearestExcludedDateSessionTo.prop('disabled', false);
		} else {
			nearestExcludedDates.hide();
			nearestExcludedDatesDateRage.each(function() {
				$(this).prop('disabled', true);
			});
			nearestExcludedDateSessionFrom.prop('disabled', true);
			nearestExcludedDateSessionTo.prop('disabled', true);
		}
	});


	$(document).on("click", "button.remove-date-row", function (e) {
		e.preventDefault();
		const table = $(this).closest('tr.multiple-session').parents('table.multiple-sessions');
		$(this).closest('.multiple-session').remove();
		correctIndexes(table);
	});

	$(document).on("change", ".session-cb", function () {
		const row = $(this).closest('.multiple-session');
		const disabled = !this.checked;
		const date = row.find("input[name$='Date']").val();
		row.find("input[name$='Date'], input[name$='StartTime'], input[name$='EndTime']").prop("disabled", disabled).removeClass('has-error');
		row.find("select[name$='StartTimeHour'], select[name$='StartTimeMinute'], select[name$='StartTimeMeridiem']").prop("disabled", disabled).removeClass('has-error');
		row.find("select[name$='EndTimeHour'], select[name$='EndTimeMinute'], select[name$='EndTimeMeridiem']").prop("disabled", disabled).removeClass('has-error');
		row.find(".invalid-feedback").remove();
		let next = row.next("tr");
		while (next && next.find("input[name$='Date']").val() === date) {
			next.find("input[name$='Date'], input[name$='StartTime'], input[name$='EndTime']").prop("disabled", disabled).removeClass('has-error');
			next.find("select[name$='StartTimeHour'], select[name$='StartTimeMinute'], select[name$='StartTimeMeridiem']").prop("disabled", disabled).removeClass('has-error');
			next.find("select[name$='EndTimeHour'], select[name$='EndTimeMinute'], select[name$='EndTimeMeridiem']").prop("disabled", disabled).removeClass('has-error');
			next.find(".invalid-feedback").remove();
			next = next.next("tr");
		}
	});

	$(document).on("click", "a.select-all-sessions", function (e) {
		e.preventDefault();
		$(this).closest('.multiple-sessions').find("input[name$='Date'], input[name$='StartTime'], input[name$='EndTime']").prop("disabled", false);
		$(this).closest('.multiple-sessions').find('.session-cb').prop("checked", true);
		$(this).closest('.multiple-sessions').find("select[name$='StartTimeHour'], select[name$='StartTimeMinute'], select[name$='StartTimeMeridiem']").prop("disabled", false);
		$(this).closest('.multiple-sessions').find("select[name$='EndTimeHour'], select[name$='EndTimeMinute'], select[name$='EndTimeMeridiem']").prop("disabled", false);
	});

	$(document).on("click", "a.deselect-all-sessions", function (e) {
		e.preventDefault();
		$(this).closest('.multiple-sessions').find("input[name$='Date'], input[name$='StartTime'], input[name$='EndTime']").prop("disabled", true);
		$(this).closest('.multiple-sessions').find('.session-cb').prop("checked", false);
		$(this).closest('.multiple-sessions').find("select[name$='StartTimeHour'], select[name$='StartTimeMinute'], select[name$='StartTimeMeridiem']").prop("disabled", true).removeClass('has-error');;
		$(this).closest('.multiple-sessions').find("select[name$='EndTimeHour'], select[name$='EndTimeMinute'], select[name$='EndTimeMeridiem']").prop("disabled", true).removeClass('has-error');;
		$(this).closest('.multiple-sessions').find(".invalid-feedback").remove();
	});

	$(document).on("change", ".multiple-sessions .multiple-session .time-selector select", function (e) {
		const selectedValue = $(this).val();
		const id = $(this).attr("id");
		const parent = $(this).closest(".multiple-session");
		const startTime = parent.find("input[name$='StartTime']");
		const startTimeValue = startTime.val();
		const endTime = parent.find("input[name$='EndTime']");
		const endTimeValue = endTime.val();
		if (id.endsWith("StartTimeHour")) {
			const updatedValue = (selectedValue.length ? selectedValue : "hh") + startTimeValue.slice(2);
			startTime.val(updatedValue);
		} else if (id.endsWith("StartTimeMinute")) {
			const updatedValue = startTimeValue.slice(0, 3) + (selectedValue.length ? selectedValue : "mm") + startTimeValue.slice(-3);
			startTime.val(updatedValue);
		} else if (id.endsWith("StartTimeMeridiem")) {
			const updatedValue = startTimeValue.slice(0, 5) + " " + (selectedValue.length ? selectedValue : "PM");
			startTime.val(updatedValue);
		} else if (id.endsWith("EndTimeHour")) {
			const updatedValue = (selectedValue.length ? selectedValue : "hh") + endTimeValue.slice(2);
			endTime.val(updatedValue);
		} else if (id.endsWith("EndTimeMinute")) {
			const updatedValue = endTimeValue.slice(0, 3) + (selectedValue.length ? selectedValue : "mm") + endTimeValue.slice(-3);
			endTime.val(updatedValue);
		} else if (id.endsWith("EndTimeMeridiem")) {
			const updatedValue = endTimeValue.slice(0, 5) + " " + (selectedValue.length ? selectedValue : "PM");
			endTime.val(updatedValue);
		}
	});

	/* ==========================================================================
	Submit
	========================================================================== */
	 
	$('#event-registration').on('submit', function (e) {
		$(".time-selector .time input[id^='Locations_'][type='hidden']").each(function () {
			if ($(this).val() == "hh:mm PM") {
				$(this).val("");
			}
		})
	 
		$(".event-registration__group.event-location input[name$='SessionType']").each(function () {
			if ($(this).val() != "ComplexDates") {
				var parent = $(this).closest(".event-location");
				parent.find(".multiple-session .time-selector select").prop("disabled", true);
			}
		})

		e.preventDefault();
		 
		if ($('#event-registration').valid()) {
			setLocationLibrariesAndCommunityVenuesIndex();

			const $submitButton = $('.submit-review');
			$submitButton
				.prop('disabled', true);

			$('.invalid-feedback').remove();
			$('.has-error').removeClass('has-error');
			$('#form-errors').html('');
			var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();

			const createFormData = () => {
				const formData = new FormData($("#event-registration")[0]);

				['MainImage', 'Image2', 'Image3', 'Image4', 'Image5', 'Image6'].forEach(id => {
					const fileInput = $('#' + id)[0];
					if (fileInput?.files.length > 0 && !formData.has(id)) {
						formData.append(id, fileInput.files[0]);
					}
				});

				formData.append('Submit', 'True');
				return formData;
			};

			const _formData = createFormData();

			const url = `/umbraco/surface/eventregistrationajax/${submitAction}`;
			const ajaxSettings = {
				url: url,
				data: _formData,
				type: 'POST',
				cache: false,
				contentType: false,
				processData: false
			};

			const enableButton = () => {
				$submitButton
					.prop('disabled', false);
			};

			if (submitAction === 'review') {
				$.ajax({
					...ajaxSettings,
					dataType: 'html',
					success: (data) => {
						$('#reviewcontent').html(data);
						$('html, body').animate({ scrollTop: 0 }, 400);

						const activeTab = $("#event-form-tabs").tabs("option", "active");
						$("#event-form-tabs").tabs("option", "active", activeTab + 1);

						$('.image-slider').slick({
							infinite: true,
							dots: false,
							prevArrow: `<div class="slick-prev slick-arrow">
							<span class="screen-reader-text">Prev</span>
							<svg class="icon" role="presentation"><use xlink:href="#icon-arrow-left"></use></svg>
						</div>`,
							nextArrow: `<div class="slick-next slick-arrow">
							<span class="screen-reader-text">Next</span>
							<svg class="icon" role="presentation"><use xlink:href="#icon-arrow-right"></use></svg>
						</div>`
						});
						enableButton();
					},
					error: (xhr) => {
						try {
							const errorData = JSON.parse(xhr.responseText);
							if (errorData.fieldErrors) {
								setErrors(xhr);
							} else {
								alert("An error has occurred making the request.");
							}
						} catch (e) {
							alert("An error has occurred making the request.");
						}
						enableButton();
					}
				});
			} else {
				$.ajax({
					...ajaxSettings,
					dataType: 'json',
					success: (response) => {
						if (response.success === true) {
							$('.event-registration').remove();
							$('.event-registration-success').show();
							$('html, body').animate({ scrollTop: 0 }, 400);
						} else {
							alert("Submission failed. Please check your inputs.");
							enableButton();
						}
					},
					error: (xhr) => {
						try {
							const errorData = JSON.parse(xhr.responseText);
							if (errorData.fieldErrors) {
								setErrors(xhr);
							} else {
								alert("An error has occurred making the request.");
							}
						} catch (e) {
							alert("An error has occurred making the request.");
						}
						enableButton();
					}
				});
			}
		} else {
			return false;
		}
	});

	function flatpickrInit() {
		$('.single-date-picker.load-init').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (dateStr)
					instance.close();
			},
			onReady: function (selectedDates, dateStr, instance) {
				$(".single-date-picker.load-init").removeClass('load-init');
			}
		});

		$('.recurring-date-range-picker.load-init').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length === 2) {
					var parent = $(instance.element.closest('.recurring-dates'));
					parent.find("input[name$='RecurringDateRangeFrom']").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					parent.find("input[name$='RecurringDateRangeTo']").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					instance.close();
				}
			},
			onReady: function (selectedDates, dateStr, instance) {
				$(".recurring-date-range-picker.load-init").removeClass('load-init');
			}
		});

		$('.excluded-date-range-picker.load-init').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length === 2) {
					var parent = $(instance.element.closest('.excluded-date'));
					parent.find("input[name$='SessionFrom']").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					parent.find("input[name$='SessionTo']").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					instance.close();
				}
			},
			onReady: function (selectedDates, dateStr, instance) {
				$(".excluded-date-range-picker.load-init").removeClass('load-init');
			}
		});

		$('.complex-date-range-picker.load-init').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length === 2) {
					var parent = $(instance.element.closest('.complex-dates'));
					var locationIndex = parent.closest('.event-location').attr('data-index');
					parent.find("input[name$='ComplexDateRangeFrom']").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					parent.find("input[name$='ComplexDateRangeDateTo']").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					var sessionTable = parent.find('.multiple-sessions:first');
					sessionTable.find('.multiple-session').remove();
					var from = selectedDates[0];
					var to = selectedDates[1];
					var day = from;
					var newIndex = 0;
					while (day <= to) {
						var newSection = eventLocationMultipleSession.clone();
						newSection.find("[name$='MultipleSessions.Index']").val(newIndex);
						newSection.find("[name$='MultipleSessions[0].Date']").val(flatpickr.formatDate(day, "Y-m-d"));
						newSection.find(".multiple-session-day").html(flatpickr.formatDate(day, "d M Y"));
						newSection.find("input, select, textarea, checkbox").each(function (index, input) {
							input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_${locationIndex}__`)
								.replace(/MultipleSessions_[0-9]+__/g, `MultipleSessions_${newIndex}__`);
							input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[${locationIndex}]`)
								.replace(/MultipleSessions\[[0-9]+\]/g, `MultipleSessions[${newIndex}]`);
						});
						newSection.find("label").each(function (index, label) {
							var l = $(label);
							l.attr('for', l.attr('for').replace(/Locations_[0-9]+__/g, `Locations_${locationIndex}__`)
								.replace(/MultipleSessions_[0-9]+__/g, `MultipleSessions_${newIndex}__`));
						});
						newSection.appendTo(sessionTable);
						newSection.find(":disabled").prop("disabled", false);

						var newDate = day.setDate(day.getDate() + 1);
						day = new Date(newDate);
						newIndex++;
					}
					sessionTable.show();
					flatpickrInit();
				}
			},
			onReady: function (selectedDates, dateStr, instance) {
				$(".complex-date-range-picker.load-init").removeClass('load-init');
			}
		});

		$('.time-picker.load-init').flatpickr({
			enableTime: true,
			noCalendar: true,
			dateFormat: "G:i K",
			disableMobile: "true",
			allowInput: true,
			onReady: function (selectedDates, dateStr, instance) {
				instance.input.classList.remove("load-init");
			},
			onChange: function (selectedDates, dateStr, instance) {
				// if this is an end time picker, trigger the validation on the start time
				if (instance.input.classList.contains("starttime")) return;
				const startTimeElement = document.getElementsByName(instance.input.name.replace("End", "Start"))[0];
				if (startTimeElement) $(startTimeElement).closest("form").data("validator").element("#" + startTimeElement.id);
			}
		});

		$('.regionwide-date-range-picker.load-init').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length === 2) {
					var parent = $(instance.element.closest('.regionwide-dates'));
					parent.find("input[name$='RegionWideDateRangeFrom']").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					parent.find("input[name$='RegionWideDateRangeTo']").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					instance.close();
				}
			},
			onReady: function (selectedDates, dateStr, instance) {
				$(".regionwide-date-range-picker.load-init").removeClass('load-init');
			}
		});

	}

	function setLocationLibrariesAndCommunityVenuesIndex() {
		const isRegionWide = !$("#location-regionwide").hasClass("button--ghost");

		if (isRegionWide) {
			//if region wide, clear single location and multi location libraries and community venues
			$(".js-single-multi-libraries input[type=radio], .js-single-multi-libraries input[type=checkbox]").prop('checked', false);
			$(".js-single-multi-community-venues input[type=radio], .js-single-multi-community-venues input[type=checkbox]").prop('checked', false);

			//set region wide libraries (Location__99) checkboxes to Location__0 for form serialize
			$("input[type=checkbox].js-regionwide-checkbox-item").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_0__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[0]`);
			});

			//set region wide community venues (Location__99) checkboxes to Location__0 for form serialize
			$("input[type=checkbox].js-regionwide-community-venue-checkbox-item").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_0__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[0]`);
			});

			//set region wide Hosted At Library (Location__99) radio buttons to Location__0 for form serialize
			$(".js-reginonwide-hostedatlibrary input[type=radio]").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_0__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[0]`);
			});
			//set region wide Hosted At Community Venue (Location__99) radio buttons to Location__0 for form serialize
			$(".js-reginonwide-hostedatcommunityvenue input[type=radio]").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_0__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[0]`);
			});

		} else {

			//clear regionwide checkboxes
			$(".js-regionwide-libraries input[type=checkbox]").prop('checked', false);
			$(".js-regionwide-community-venues input[type=checkbox]").prop('checked', false);

			//set Location__99 checkboxes back to Location__99 for form serialize (wont be serialized)
			$("input[type=checkbox].js-regionwide-checkbox-item").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_99__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[99]`);
			});

			//set Location__99 checkboxes back to Location__99 for form serialize (wont be serialized)
			$("input[type=checkbox].js-regionwide-community-venue-checkbox-item").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_99__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[99]`);
			});

			//set region wide Hosted At Library radio buttons back to Location__99 for form serialize (wont be serialized)
			$(".js-reginonwide-hostedatlibrary input[type=radio]").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_99__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[99]`);
			});

			//set region wide Hosted At Community Venue radio buttons back to Location__99 for form serialize (wont be serialized)
			$(".js-reginonwide-hostedatcommunityvenue input[type=radio]").each(function (index, input) {
				input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_99__`);
				input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[99]`);
			});
		}

	}

	function addLocation() {
		var newIndex = $('.event-location').length;
		var newSection = eventLocation.clone();
		newSection.attr('data-index', newIndex);
		newSection.find(`[name='Locations.Index']`).val(newIndex);
		newSection.find(`[name='Locations[0].RunningFrom']`).val('');
		newSection.find(`[name='Locations[0].RunningTo']`).val('');
		newSection.find("input, select, textarea").each(function (index, input) {
			input.id = input.id.replace(/Locations_[0-9]+__/g, `Locations_${newIndex}__`);
			input.name = input.name.replace(/Locations\[[0-9]+\]/g, `Locations[${newIndex}]`);
		});
		newSection.find("label").each(function (index, label) {
			var l = $(label);
			if (l.attr('for')) {
				l.attr('for', l.attr('for').replace(/Locations_[0-9]+__/g, `Locations_${newIndex}__`));
			}
		});
		newSection.appendTo($('.event-locations').last());
		// enable all delete location buttons, if there was only one before, the delete button would have been hidden
		$(".delete-event-location").show();
		updateLocationHeadings();
		flatpickrInit();
	}

	function updateLocationHeadings() {
		$('.event-location-index').html('');
		if ($('.event-location').length && $('.event-location').length > 1) {
			$(".event-location").each(function (index) {
				$(this).find('.event-location-index').html('for location ' + (index + 1));
			});
		}
	}

	function copyContactDetails() {
		$("input[name='ContactName']").val($("input[name='FirstName']").val() + " " + $("input[name='LastName']").val());
		$("input[name='ContactEmail']").val($("input[name='Email']").val());
		$("input[name='ContactPhone']").val($("input[name='Phone']").val());
	}

	function submitForm(_formData) {
		$(':input[type="submit"]').prop('disabled', true);
		$('.invalid-feedback').remove();
		$('.has-error').removeClass('has-error');
		$('#form-errors').html('');

		var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();

		var mainImage = $('#MainImage')[0].files;
		if (mainImage.length > 0 && !_formData.has('MainImage')) {
			_formData.append('MainImage', mainImage[0]);
		}

		var image2 = $('#Image2')[0].files;
		if (image2.length > 0 && !_formData.has('Image2')) {
			_formData.append('Image2', image2[0]);
		}

		var image3 = $('#Image3')[0].files;
		if (image3.length > 0 && !_formData.has('Image3')) {
			_formData.append('Image3', image3[0]);
		}

		var image4 = $('#Image4')[0].files;
		if (image4.length > 0 && !_formData.has('Image4')) {
			_formData.append('Image4', image4[0]);
		}

		var image5 = $('#Image5')[0].files;
		if (image5.length > 0 && !_formData.has('Image5')) {
			_formData.append('Image5', image5[0]);
		}

		var image6 = $('#Image6')[0].files;
		if (image6.length > 0 && !_formData.has('Image6')) {
			_formData.append('Image6', image6[0]);
		}

		_formData.append('Submit', "True"); 

		$.ajax({
			url: '/umbraco/surface/eventregistrationajax/'+action,
			data: _formData,
			type: 'POST',
			dataType: "json",
			cache: false,
			contentType: false,
			processData: false,
			success: function (response) {
				if (response.success === true) {
					$('.event-registration').remove();
					$('.event-registration-success').show();
					$('html, body').animate({ scrollTop: 0 }, 400);
				}
				$(':input[type="submit"]').prop('disabled', false);
				  
			},
			error: function (XMLHttpRequest, textStatus, errorThrown) {
				if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.fieldErrors) {
					setErrors(XMLHttpRequest);
				} else {
					alert("An error has occurred making the request");
				}
				$(':input[type="submit"]').prop('disabled', false);
			}
		});
	}
	function hasImageTag(string) {
		// Regular expression to match an <img> tag
		const imgRegex = /<img[^>]*>/;
		return imgRegex.test(string);
	}
	function setErrors(XMLHttpRequest) {
		var hasImageError = false;
		jQuery.each(JSON.parse(XMLHttpRequest.responseText).fieldErrors, function (index) {
			var field = this["field"];
			var error = this["error"];
			//find existing label
			var $errorLabel = $("label.invalid-feedback[for='" + field + "']");
			if ($errorLabel.length) {
				$errorLabel.text(error).show();
			} else {
				var errorText = '<label for="' + field + '" class="invalid-feedback has-error">' + error + '</label>';
				if (field === "EventTypes" || field === "Associations" || field === "EventCostType" || field === "MultipleSessions") {
					$("#" + field).after(errorText);
				} else {
					$("[name='" + field + "']").each(function () {
						if ($(this).hasClass('single-date-picker') || $(this).hasClass('recurring-date-range-picker') || $(this).hasClass('complex-date-range-picker')) {
							$(this).next('.form-control').addClass('has-error');
							$(this).next('.form-control').after(errorText);
						} else {
							$(this).addClass('has-error');
							$(this).after(errorText);
						}
					});
				}
			}
			if (field == "MainImage" || field.startsWith("Image")) {
				hasImageError = true;
				$("#tabs-3 .event-registration__page .event-registration__intro .event-registration__intro-content").first().append(`<p class="invalid-feedback image-upload">${error}</p>`);
			} else {
				$('#form-errors').append(`<p class="invalid-feedback">${error}</p>`);
			}
		});
		$([document.documentElement, document.body]).animate({
			scrollTop: hasImageError ? 150 : $("#form-errors").offset().top - 200
		}, 200);
	}

	/* ==========================================================================
	   Tabs
	   ========================================================================== */
	 
	$("#event-form-tabs").tabs({
		
		beforeActivate: function (event, ui) {
			if (!ui.newPanel.hasClass('validated') && !$("#event-registration").valid()) {
				if ($(".has-error").length) {
					$([document.documentElement, document.body]).animate({
						scrollTop: $(".has-error").first().offset().top - $("header").outerHeight()
					}, 200);
				}
				ui.oldPanel.removeClass('validated');
				return false;
			} else {
				ui.oldPanel.addClass('validated');
			}
		}
	});

	$(".js-next-tab").click(function (e) {
		e.preventDefault();
		if (!$("#event-registration").valid()) {
			// scroll first error into view
			$('html, body').animate({ scrollTop: ($('.has-error:visible').offset().top - $("header").outerHeight()) }, 400);
			return;
		}

		var active = $("#event-form-tabs").tabs("option", "active");
		$("#event-form-tabs").tabs("option", "active", active + 1);
		// scroll to top
		$('html, body').animate({ scrollTop: $("#event-form-tabs").offset().top - $("header").outerHeight() }, 400);
	});

	$(".js-prev-tab").click(function (e) {
		e.preventDefault();
		var active = $("#event-form-tabs").tabs("option", "active");
		$("#event-form-tabs").tabs("option", "active", active - 1);
		// scroll to top
		$('html, body').animate({ scrollTop: $("#event-form-tabs").offset().top - $("header").outerHeight() }, 400);
	});

	/* ==========================================================================
	Images
	========================================================================== */

	$(document).on("click", "#addEventImageBtn", function (e) {
		e.preventDefault();
		var nextImage = $('input.additional-image-hidden:file').first();
		nextImage.removeClass('additional-image-hidden');
		nextImage.closest('.column-wrapper').show();
		if ($('input.additional-image-hidden:file').length === 0) {
			$(this).remove();
		}
	});

	$(document).on("change", ".event-registration-image-field", function (e) {
		var file = e.target.files[0];
		var img = $(this).closest(".column-wrapper").find(".event-registration-preview-image");
		img.siblings(".event-registration-remove-image").show();
		let reader = new FileReader();
		reader.onload = function (event) {
			img.attr('src', event.target.result);
		}
		reader.readAsDataURL(file);
	});

	$(document).on("click", ".event-registration-remove-image", function () {
		$(this).hide();
		$(this).siblings(".event-registration-preview-image").attr('src', "");
		$(this).closest(".column-wrapper").find(".event-registration-image-field").val("");
	});

	/* ==========================================================================
	Url fields
	========================================================================== */
	$('input.url').on('change', function () {
		var urlVal = $(this).val().trim();
		if (urlVal && !urlVal.startsWith('http')) {
			$(this).val('https://' + urlVal);
		}
	})
	 
	$(".submit-review").on("click", function (e) {
		e.preventDefault();

		const $submitButton = $(this);
		submitAction = $submitButton.attr('name');

		$('#event-registration').data('submitButton', $submitButton).submit();
	});

	$(document).on("click", ".edit-details", function (e) {
		var active = $("#event-form-tabs").tabs("option", "active");
		$("#event-form-tabs").tabs("option", "active", active - 2);
	});
	
});
